import type { TipoCampo } from '../../api/tipos';

export const TIPOS_CAMPO: { valor: TipoCampo; etiqueta: string }[] = [
  { valor: 'RADIO', etiqueta: 'Opción única' },
  { valor: 'CHECK', etiqueta: 'Opción múltiple' },
];

/// Si el administrador no toca la hora de cierre, cierra al final del día.
/// Tiene que coincidir con HORA_CIERRE_POR_DEFECTO del backend.
export const HORA_CIERRE_POR_DEFECTO = '23:59';

/// Paleta sugerida para los tipos de evento. El administrador puede escribir
/// cualquier color; esto es solo para elegir rápido.
export const COLORES_SUGERIDOS = [
  '#A1C623',
  '#29B0E6',
  '#6AB333',
  '#2B90CF',
  '#1166B0',
  '#12A039',
  '#E8C24A',
  '#E08A7E',
];

/// Clave estable para las preguntas que todavía no existen en la base.
let contador = 0;
export const nuevaClaveLocal = () => `local-${(contador += 1)}`;
